import { render, staticRenderFns } from "./WishArea.vue?vue&type=template&id=a6b7e0a0&"
import script from "./WishArea.vue?vue&type=script&lang=js&"
export * from "./WishArea.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports